import {
  initialState,
  Actions,
  State,
  DELETE_JUDICIAL,
  DELETE_JUDICIAL_SUCCESS,
  DELETE_JUDICIAL_ERROR,
  RESET_DELETE_JUDICIAL,
} from "../../types/judicial/delete";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case DELETE_JUDICIAL:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case DELETE_JUDICIAL_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case DELETE_JUDICIAL_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      };
    case RESET_DELETE_JUDICIAL:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducers;
